import { render } from "./ChatConversation.vue?vue&type=template&id=405de2fd"
import script from "./ChatConversation.vue?vue&type=script&lang=js"
export * from "./ChatConversation.vue?vue&type=script&lang=js"

import "./ChatConversation.vue?vue&type=style&index=0&id=405de2fd&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__